<template>
  <!-- 考勤周期设置 -->
  <el-dialog :title="$t('1943')" :visible.sync="visible" :close-on-click-modal="false" :show-close="false">
    <div class="dialog-content">
      <p class="margin-bottom">{{ titleDetail }}</p>
      <el-form>
        <p>
          <!-- 月份 -->
          <el-form-item class="inline">
            <el-select
              v-model="form.month_at"
              class="short-select"
              :placeholder="$t('221')"
              @change="form.month_date = ''"
            >
              <el-option v-for="item in selectDate" :key="item.value" :label="$t(item.label)" :value="item.value" />
            </el-select>
          </el-form-item>
          <!-- 日期 -->
          <el-form-item class="inline margin-left">
            <el-select v-model="form.month_date" class="short-select" :placeholder="$t('221')">
              <el-option v-for="item in optionalDate" :key="item" :label="$t('1963', { x: item })" :value="item" />
            </el-select>
          </el-form-item>
          <!--
            至 - 结束日期
            开始日期确定的情况下展示
          -->
          <span class="inline margin-left" v-if="form.month_date && form.month_at">
            {{ $t('1966') }} {{ endDate }}</span
          >
        </p>
        <!-- 提示影响范围 -->
        <p style="font-size: 14px; opacity: 0.5">{{ $t('1946') }}</p>
      </el-form>
    </div>
    <!-- 底部操作栏 -->
    <span slot="footer" class="dialog-footer" v-if="type === 1">
      <el-button type="primary" @click="goback" :loading="subLoad">{{ $t('1969') }}</el-button>
      <el-button type="primary" @click="doSubmit" :loading="subLoad">{{ $t('131') }}</el-button>
    </span>
    <span slot="footer" class="dialog-footer" v-else>
      <el-checkbox v-model="confirmRisks" class="left-box">{{ $t('1947') }}</el-checkbox>
      <!-- 放弃修改 -->
      <el-button @click="handlerCancel" :disabled="subLoad">{{ $t('1948') }}</el-button>
      <!-- 确认修改 -->
      <el-button type="primary" @click="doSubmit" :loading="subLoad" :disabled="!confirmRisks">{{
        $t('1949')
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
// 获取当前月份
import { setAttendanceCycle, getAttendanceCycle } from 'api/Attendance/monthly-statistics'
const month = new Date().getMonth() + 1
// 上月
const lastMonth = month - 1 < 1 ? 12 : month - 1
// 获取当月的最后一天
const getLastDate = month => {
  let year = new Date().getFullYear()
  if (month < lastMonth) year -= 1
  return new Date(year, month, 0).getDate()
}
// 可选月份 固定为上月与本月
const selectDate = $t => [
  {
    label: $t('last_mouth'),
    value: lastMonth
  },
  {
    label: $t('1950'),
    value: month
  }
]
export default {
  props: {
    // 1 新增（新增时如果已经存在则提示刷新） 2 更新
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      visible: false,
      // 可选月份 固定为上月与本月
      selectDate: selectDate(this.$t),
      form: {
        month_at: month, // 可选月份
        month_date: 1 // 选择日期
      },
      confirmRisks: false, // 风险确认
      subLoad: false // 提交loading
    }
  },
  computed: {
    // 天数选项
    optionalDate: vm => {
      // 最大可选日期
      // 所选月份最后一天
      const maxDate = getLastDate(vm.form.month_at)
      // 最小可选日期
      // 开始日期可选范围为上月2日至当月31日，
      const minDate = vm.form.month_at === month ? 1 : 2
      return Array.from({ length: maxDate }, (_, index) => index + 1).filter(item => item >= minDate)
    },
    // 1. 开始日期为上月x日时，则结束日期为当月x-1日
    // 2. 开始日期为当月y日时，则结束日期为次月y-1日
    // 3. 特殊的，当开始日期为当月1日时，结束日期为本月底
    endDate: vm => {
      const { month_at, month_date } = vm.form
      if (month_at === month && month_date === 1) return vm.$t('1951')
      // `次月${month_date - 1}日`
      if (month_at === month) return vm.$t('1952', { x: month_date - 1 })
      // `当月${month_date - 1}日`
      return vm.$t('1953', { x: month_date - 1 })
    },
    // 标题 区分编辑和修改
    titleDetail: vm => (vm.type === 1 ? vm.$t('1954') : vm.$t('71')),
    // 考勤展示文案 例：本月10号到下月10号
    attendanceText: vm => {
      const { month_at, month_date } = vm.form
      if (month_at === month && month_date === 1) return vm.$t('attend_month2')
      if (month_at === month) return vm.$t('attend_month3', { x: month_date, y: month_date - 1 })
      return vm.$t('attend_month1', { x: month_date, y: month_date - 1 })
    }
  },
  mounted() {
    if (this.type === 2) {
      getAttendanceCycle().then(res => {
        // 可选日期转换 // 1 上月 2 本月
        this.form = res.data
        this.form.month_at = res.data.month_at === 2 ? month : lastMonth
        this.handlerUpdate()
      })
    }
  },
  methods: {
    goback() {
      this.$router.go(-1)
    },
    // 更新父元素文案
    handlerUpdate() {
      this.$nextTick(() => {
        this.$emit('updateText', this.attendanceText)
      })
    },
    // 提交
    doSubmit() {
      this.subLoad = true
      // 可选日期转换 // 1 上月 2 本月
      const params = {
        ...this.form,
        set_type: this.type,
        month_at: this.form.month_at === month ? 2 : 1
      }
      setAttendanceCycle(params)
        .then(res => {
          //  关闭弹窗 数据更新
          this.handlerCancel()
          this.handlerUpdate()
          if (params.set_type === 1) this.$emit('init')
        })
        .finally(() => (this.subLoad = false))
    },
    // 关闭弹窗
    handlerCancel() {
      this.visible = false
    }
  }
}
</script>

<style></style>
